import React, { useState, useEffect, useContext } from "react";
import "./statement.css";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { HOST_URL, LOCAL_STORAGE_KEY } from "../../../config";
import { getUserData } from "../../common/utility/Utils";
import { makeStyles } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import InfiniteScroll from "react-infinite-scroller";
import { StoreContext } from "../../../store/Provider";
import axios from "axios";
import moment from "moment";
// import MainLayout from "../../common/Layout/MainLayout";
// import LayoutWithLogin from '../../common/Layout/LayoutWithLogin';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff"
  }
}));

const Statements = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [open, setOpen] = useState(false);
  const pageSize = 20;
  const [statementData, setStatementData] = useState([]);
  const [docDownloading, setDocDownloading] = useState([]);
  const [hasmore, setHasMore] = useState(false);
  const [loadingMore, setLoadingMore] = useState(true);
  const context = useContext(StoreContext);
  // const [payLoading, setPayLoading] = useState(false);

  useEffect(() => {
    getdata(pageNumber);
  }, []);

  const getdata = async (pageNumber) => {
    if (pageNumber === 1) {
      setLoading(true);
    }
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const URL = `${HOST_URL}api/v2/OutStandingData/${data.user_country_code}/Get/${data.user_company_code}?page.pageNumber=${pageNumber}&page.pageSize=${pageSize}`;
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: ""
    };
    axios
      .get(URL, {
        headers: header
      })
      .then((res) => {
        let count = pageNumber + 1;
        let hasMorecheck = res.data.Data.length === 20 ? true : false;
        setHasMore(hasMorecheck);
        if (pageNumber === 1) {
          setStatementData(res.data.Data);
        } else {
          setStatementData([...statementData, ...res.data.Data]);
        }
        setLoading(false);
        setPageNumber(count);
        setLoadingMore(true);
      })
      .catch((res) => {
        console.log(res);
        setLoading(false);
        setOpenalert(true);
        setSeverity("error");
        setAlertText("Something went wrong!");
      });
  };

  const loadMore = () => {
    if (loadingMore) {
      getdata(pageNumber);
      setLoadingMore(false);
    }
  };

  const onDocDownload = async (row) => {
    setOpen(true);
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: ""
    };
    let params = {
      Source: [
        {
          Type: "AccountingInvoice",
          Key: `${row.AR ?? "AR"} ${row.Type} ${row.TransactionNumber}`
        }
      ],
      FilterCol: [
        {
          Type: "IsPublished",
          Value: "true"
        }
      ],
      IsFilterApplied: true
    };
    const URL = `${HOST_URL}api/v1/DocumentData/${data.user_company_code}/ShipmentDocument`;
    axios
      .post(URL, params, {
        headers: header
      })
      .then((res) => {
        setOpen(false);
        const pdf = res.data[0].ImageData;
        const linkSource = `data:application/pdf;base64,${pdf}`;
        const downloadLink = document.createElement("a");
        const fileName = res.data[0].FullName;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((err) => {
        setOpen(false);
        console.log(err);
        setOpenalert(true);
        setSeverity("error");
        setAlertText("Something went wrong!");
      });
  };

  const onPay = () => {
    // setOpen(true);
    setOpenalert(true);
    setSeverity("info");
    setAlertText("This feature is under development!");
  };

  const [openalert, setOpenalert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  return (
    <>
      {loading ? (
        <div className="loadingClass">
          <CircularProgress size="1.5rem" />
        </div>
      ) : (
        <div className="dashComponent">
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={openalert}
            autoHideDuration={3000}
            onClose={handleClose}
          >
            <Alert severity={severity} onClose={handleClose}>
              {alertText}
            </Alert>
          </Snackbar>
          <div className="dashHeader">
            <h6>Check your account statements here</h6>
          </div>
          <div className="statementBody dashBoard">
            <TableContainer style={{ height: "100%" }}>
              <InfiniteScroll
                pageStart={0}
                loadMore={loadMore}
                hasMore={hasmore}
                loader={
                  <div className="bottomLoader">
                    <CircularProgress size="1.5rem" />
                  </div>
                }
                useWindow={false}
              >
                <Table stickyHeader style={{ height: loading ? "100%" : "" }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Invoice #</TableCell>
                      <TableCell>Shipment #</TableCell>
                      <TableCell>Consignee</TableCell>
                      <TableCell>PO Number</TableCell>
                      <TableCell>BL Number</TableCell>
                      <TableCell>Due Date</TableCell>
                      <TableCell>Invoice Date</TableCell>
                      <TableCell>Invoiced Amount</TableCell>
                      <TableCell align="center">Action</TableCell>
                    </TableRow>
                  </TableHead>
                  {loading ? (
                    <TableBody>
                      <tr className="finanaceloadertr">
                        <td className="finanaceloadertd" colSpan="8">
                          <CircularProgress size="1.5rem" />
                        </td>
                      </tr>
                    </TableBody>
                  ) : (
                    <TableBody>
                      {statementData.map((row, index) => {
                        const uniqueClass = `rowId-${index}`;
                        return (
                          <TableRow
                            hover
                            tabIndex={-1}
                            key={index}
                            className={uniqueClass}
                          >
                            <TableCell title={row.TransactionNumber}>
                              {row.TransactionNumber}
                            </TableCell>
                            <TableCell title={row.JobInvoiceNumber}>
                              {row.JobInvoiceNumber}
                            </TableCell>
                            <TableCell title={row.ConsigneeFullName}>
                              {row.ConsigneeFullName}
                            </TableCell>
                            <TableCell title={row.PONumber}>
                              {row.PONumber}
                            </TableCell>
                            <TableCell title={row.BLNumber}>
                              {row.BLNumber}
                            </TableCell>
                            <TableCell
                              title={moment(row.DueDate).format("MM/DD/YYYY")}
                            >
                              {moment(row.DueDate).format("MM/DD/YYYY")}
                            </TableCell>
                            <TableCell
                              title={moment(row.InvoiceDate).format(
                                "MM/DD/YYYY"
                              )}
                            >
                              {moment(row.InvoiceDate).format("MM/DD/YYYY")}
                            </TableCell>
                            <TableCell>
                              ${context.calculateAmmount(row.InvoicedAmount)}
                            </TableCell>
                            <TableCell align="center">
                              <div className="actionTableData">
                                <Button
                                  title="Download"
                                  className="statementDownload"
                                  onClick={() => onDocDownload(row)}
                                >
                                  <i className="fas fa-download" />
                                </Button>
                                {/* <Button title='Pay' className="statementPay" onClick={() => onPay()}>Pay</Button> */}
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                </Table>
              </InfiniteScroll>
            </TableContainer>
          </div>
          <Backdrop className={classes.backdrop} open={open}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </div>
      )}
    </>
  );
};
export default Statements;
